import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { createContentMedium, updateContentMedium, getContentMediumAdmin } from '../../../api/contentAdminApi';
import { CmsFormShell } from './CmsFormFields';

const EMPTY = {
	title: '', file_url: '', media_type: 'image', alt_text: '', caption: '',
	copyright_holder: '', photographer: '', source_name: '', published: true,
};

export default function MediaAdminForm() {
	const { id } = useParams();
	const history = useHistory();
	const isEdit = Boolean(id);
	const [form, setForm] = useState(EMPTY);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (!isEdit) return;
		getContentMediumAdmin(id)
			.then((res) => setForm({ ...EMPTY, ...(res.data?.content_medium || res.data) }))
			.catch(() => swal('Error', 'Could not load media', 'error'));
	}, [isEdit, id]);

	const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));

	const handleSubmit = async (e) => {
		e.preventDefault();
		setSaving(true);
		try {
			if (isEdit) await updateContentMedium(id, form);
			else await createContentMedium(form);
			swal('Saved', 'Media saved.', 'success');
			history.push('/admin/cms/media');
		} catch (err) {
			swal('Error', err.response?.data?.errors?.[0] || 'Could not save', 'error');
		} finally {
			setSaving(false);
		}
	};

	return (
		<CmsFormShell title={isEdit ? `Edit: ${form.title}` : 'New media'} backHref="/admin/cms/media" onSubmit={handleSubmit} saving={saving}>
			<fieldset className="admin-cms-form__section">
				<legend>Media file</legend>
				<label><span>Title</span><input required value={form.title} onChange={(e) => onChange('title', e.target.value)} /></label>
				<label><span>File URL</span><input required value={form.file_url} onChange={(e) => onChange('file_url', e.target.value)} placeholder="https://… or /images/…" /></label>
				<div className="admin-cms-form__row">
					<label>
						<span>Type</span>
						<select value={form.media_type} onChange={(e) => onChange('media_type', e.target.value)}>
							{['image', 'video', 'pdf', 'gpx', 'download'].map((t) => <option key={t} value={t}>{t}</option>)}
						</select>
					</label>
					<label className="admin-cms-form__check">
						<input type="checkbox" checked={!!form.published} onChange={(e) => onChange('published', e.target.checked)} /> Published
					</label>
				</div>
				<label><span>Alt text</span><input value={form.alt_text || ''} onChange={(e) => onChange('alt_text', e.target.value)} /></label>
				<label><span>Caption</span><input value={form.caption || ''} onChange={(e) => onChange('caption', e.target.value)} /></label>
				<div className="admin-cms-form__row">
					<label><span>Photographer</span><input value={form.photographer || ''} onChange={(e) => onChange('photographer', e.target.value)} /></label>
					<label><span>Copyright</span><input value={form.copyright_holder || ''} onChange={(e) => onChange('copyright_holder', e.target.value)} /></label>
				</div>
				<label><span>Source</span><input value={form.source_name || ''} onChange={(e) => onChange('source_name', e.target.value)} /></label>
			</fieldset>
		</CmsFormShell>
	);
}
